module.exports = __webpack_public_path__ + "mainassets/img/send-white.0256d5c4.svg";